// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function RecordsWrapper(Props) {
  var children = Props.children;
  return React.createElement("div", {
              className: "c-records-body"
            }, children);
}

var make = RecordsWrapper;

export {
  make ,
  
}
/* react Not a pure module */
